import React, { useState } from 'react';
import WorkplaceSelect from './WokrplaceSelect';
import { SelectValue } from '../../../../Components/Base/Select/Select';

interface Props {
	name: string;
	isRequired?: boolean;
	placeholder?: string;
	value?: string;
	onChange?: (value: string) => void;
	excludedIds?: string[];
}

const WorkplaceSelectPHP: React.FC<Props> = ({
	value,
	onChange,
	name,
	excludedIds,
}) => {
	const [val, setVal] = useState(value);
	const handleOnChange = (value: SelectValue) => {
		setVal(value?.value);
		onChange?.(value?.value);
	};

	return (
		<>
			<WorkplaceSelect
				value={val}
				onChange={value => handleOnChange(value)}
				workplaceType=''
				excludedIds={excludedIds}
			/>
			<input style={{ display: 'none' }} name={name} value={val} />
		</>
	);
};

export default WorkplaceSelectPHP;
